<template>
 <page>

   <head-nav :title="$t('language.page_news')">
      <icon-button-back slot="left"></icon-button-back>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

<scroll-page>

    
    <caroussel  v-if="computeCarousselMediaList.length" :medias="computeCarousselMediaList"/>
    
    <media-list v-if="computeFileList.length" :medias="computeFileList"></media-list>
  
    
    <page-padding>
      <text-block><div class="date">{{news_item.date}}</div></text-block>
      <h2 class="title">
        <ui-icon v-if="computeApproveAccess" @click.native="toggleSticky" icon="thumbtack" backgroundColor="transparent" :color="computeStickyColor" class="thumbtack"/>
        {{news_item.title}}
      </h2>
      
      <text-block v-html="news_item.text"></text-block>
      
      <text-block v-if="computeMotivatieAccess" class="motivatie">
        
        <div class="label">
          {{$t('language.message_from_teacher')}}
        </div>
        <div>
          <news-status-chip :item="news_item"/>
          {{news_item.reason_reject}}
        </div>
        
      </text-block>
      
    <div v-if="computeApproveAccess">
      <divider title="language.message_from_teacher"/>
      <ui-textarea  title="language.add_reject_reason" val="" @input="(v)=>{reason_reject = v}"></ui-textarea>
      
      
      <!--<ui-check :val="check.feed_groep" v-on:selected="val=>{check.feed_groep = val}" title="language.place_in_feed_groep" />-->
      <ui-check :val="check.website" v-on:selected="val=>{check.website = val}" title="language.place_on_website" />
      <ui-check :val="check.narrowcasting" v-on:selected="val=>{check.narrowcasting = val}" title="language.place_on_narrow" />
      <ui-check :val="check.allow_reactions" v-on:selected="val=>{check.allow_reactions = val}" title="language.allow_reactions" />
      <!--<ui-check :val="check.sticky" v-on:selected="val=>{check.sticky = val}" title="language.sticky" />-->
              
      
      <div class="approve-btn-ontainer">
        <button-activate :active="buttonActive" v-on:click.native="approveNewsItem(1)" title="language.approve"></button-activate>
        <div class="spacer"></div>
        <button-deactivate :active="buttonActive" v-on:click.native="approveNewsItem(0)" title="language.reject"></button-deactivate>
      </div>
    </div>
    
    <div v-if='news_item.allow_reactions=="1" '>

        <divider title="language.react"/>
        <emoticon-select @selected="userSelectedEmoticon" :user-choice="parseInt(news_item.my_icon_type)" :counters="news_item.icons"/>
        <ui-textarea class="text-height" title="language.add_reaction" v-bind:val="reactionText" @input="(v)=>{reactionText = v}"></ui-textarea>
        <div class="button-container">
          <div class="btn_add_reaction" @click="postReactie">{{$t('language.send')}}</div>
        </div>

        <!-- plotting reactions -->
        <divider title="language.reactions"/>
        <div class="reaction" v-for="(item,index) in news_item.reactions" :key="index">
          <ratio-image :cover="true" class="avatar" :src="getAvatarSrc(item)"></ratio-image>
          
          <div class="name">{{item.name}}</div>
          <div class="text">{{item.text}}</div>
          <div class="clear"></div>
          <ui-icon v-if="showDelete(item)" @click.native="deleteNewsReaction(item.id)" class="delete" icon="times"/>
        </div>

        <text-block v-if="!computeHasReactions">{{$t('language.no_reactions')}}</text-block>
    </div>
    </page-padding>
 </scroll-page>
   </page>
</template>

<script>

import { mapState } from 'vuex';
import Page from '../pages/Page.vue';
import PagePadding from '../components/PagePadding.vue';
import TextBlock from '../components/TextBlock.vue';
import HeadNav from '../components/HeadNav.vue';
import Caroussel from '../components/caroussel/Caroussel.vue';
import MediaList from '../components/medialist/MediaList.vue';
import IconButtonHome from '../components/buttons/IconButtonHome.vue';
import IconButtonBack from '../components/buttons/IconButtonBack.vue';
import EmoticonSelect from '../components/EmoticonSelect.vue';
import UiTextarea from '../components/UiTextarea.vue';
import ScrollPage from '../components/ScrollPage.vue';
import Divider from '../components/dividers/Divider.vue';
import i18n from "../language.js";
import RatioImage from '../components/RatioImage.vue';
import ButtonActivate from '../components/buttons/ButtonActivate.vue';
import ButtonDeactivate from '../components/buttons/ButtonDeactivate.vue';
import { USER_LEVEL } from '../settings/USER_LEVEL.js';
import UiIcon from '../components/UiIcon.vue';
import { modalService } from '../services/ModalService.js';
import NewsStatusChip from '../components/news/NewsStatusChip.vue';
import { history } from "../services/History.js";
import UiCheck from '../components/UiCheck.vue'
import { helper } from '../services/Helper.js';


export default {
  name: 'view-news-item-page',
  data:function(){
    return{
      id:this.$route.params.id, /*news_item  id*/
      reactionText:"",
      media:[],
      buttonActive:true,
      reason_reject:"",
      check:{
        //feed_groep:false,
        website:false,
        narrowcasting:false,
        allow_reactions:false,
        sticky:false,
      },
    }
  },
  computed:{
     ...mapState([
       'news_item','appSettings','user_schools'
       ]),
       computeMotivatieAccess(){
         if(!this.news_item.reason_reject){
           return false;
         }
         // if it is "me" student then show motivation
         if(this.appSettings.user_level==USER_LEVEL.STUDENT){
          var school = this.user_schools.find(school => school.active === 1);
          
          if(school.username==this.news_item.user_email){
            return true;
          }else{
            return false;
          }
        }
        if(this.appSettings.user_level==USER_LEVEL.ADMIN){
          return true;
        }
        if(this.appSettings.user_level==USER_LEVEL.TEACHER){
          return true;
        }
        if(this.appSettings.user_level==USER_LEVEL.PARENT){
          return false;
        }
        return false;
       },
       computeApproveAccess(){
         if(!this.appSettings){
           return false;
         }
         
         if(this.appSettings.user_level==USER_LEVEL.ADMIN){
           if(this.news_item.status=="pending"){
             return true;
           }else{
               return false;
           }
           
         }
         if(this.appSettings.user_level==USER_LEVEL.TEACHER){
            if(this.news_item.status=="pending"){
             return true;
           }else{
               return false;
           }
         }
         return false;
       },
       computeHasReactions(){
         return this.news_item.reactions ? this.news_item.reactions.length : false;
       },
       computeCarousselMediaList(){
         
         var medias=this.news_item.media || [];

        // only get jpg and png
        medias=medias.filter(media => (media.type =="jpg" || media.type =="png" ));

        // if news item has youtube id
         if(this.news_item.youtube_id){
            // add youtube video to start of media list
         medias.unshift({
              type:"youtube",
              youtubeId:this.news_item.youtube_id,
              url:"https://i1.ytimg.com/vi/"+this.news_item.youtube_id+"/hqdefault.jpg",
              thumbnail:"https://i1.ytimg.com/vi/"+this.news_item.youtube_id+"/default.jpg",
             })
         }

         return medias;
       },
       computeFileList(){
         var medias=this.news_item.media || [];
        
         // only get jpg and png
         medias=medias.filter(media => (media.type =="mp3" || media.type =="pdf" ));
        
        return medias
       },
       computeStickyColor(){
        if(this.check.sticky){
          return '#8CC63E';
        }
        return '#707070';
      }
      
  },
  components: {
    PagePadding,
    HeadNav,
    IconButtonHome,
    IconButtonBack,
    Page,
    TextBlock,
    EmoticonSelect,
    UiTextarea,
    ScrollPage,
    Divider,
    Caroussel,
    MediaList,
    RatioImage,
    ButtonActivate,
    ButtonDeactivate,
    UiIcon,
    NewsStatusChip,
    UiCheck,
  },
  methods:{
    back(){
      this.$router.push(history.get());
    },
    getAvatarSrc(item){
      var timestamp="?ts="+new Date().getTime();
      
      //return item.avatar ? item.avatar+timestamp : undefined;
      return item.avatar ? item.avatar+timestamp : this.composeReactionAvatar(item);
    },
    composeReactionAvatar(item){

      return helper.composeAvatarImage(item.name);

    },
    
    deleteNewsReaction(reaction_id){

      modalService.createModal(i18n.t('language.delete_reaction_sure')).then(
      ()=>{
        var payload={
          article_id:this.id,
          id:reaction_id,
        }
        this.$store.dispatch('delete_news_item_reaction',payload);
      })

      
    },
    approveNewsItem(v){
      this.buttonActive=false;

      
      var payload={
          id:this.id,
          approve:v,
          reason_reject:this.reason_reject,
          //feed_groep:this.check.feed_groep ? 1:0,
          website:this.check.website ? 1:0,
          narrowcasting:this.check.narrowcasting ? 1:0,
          allow_reactions:this.check.allow_reactions ? 1:0,
          sticky:this.check.sticky ? 1:0,
      }

      this.$store.dispatch('approve_news_item',payload).then(()=>{
        this.buttonActive=true;
        this.back();
      })
    },
    userSelectedEmoticon(id){
      var payload={
        icon_type:id,
        article_id:this.id,
      }
      this.$store.dispatch('add_news_emoticon',payload);
      
    },
    loadNewsItem(){
      this.$store.dispatch('get_news_item',{id:this.id}).then(
        ()=>{
         
          //this.check.feed_groep=(this.news_item.feed_groep=="1") ? true: false
          this.check.website=(this.news_item.website=="1") ? true: false
          this.check.narrowcasting=(this.news_item.narrowcasting=="1") ? true: false
          this.check.allow_reactions=(this.news_item.allow_reactions=="1") ? true: false
          this.check.sticky=(this.news_item.sticky=="1") ? true: false
        }
      )
    },
    postReactie(){
      var payload={
        article_id:this.id,
        text:this.reactionText,
      }
      this.$store.dispatch('add_news_item_reaction',payload);
      this.reactionText="";
      
    },
    reactionAvatarError(e){
      e.target.src= require('../assets/default_avatar.png');
    },
    showDelete(reaction){
        if(this.appSettings.user_level==USER_LEVEL.STUDENT){
          var school = this.user_schools.find(school => school.active === 1);
          
          if(school.username==reaction.email){
            return true;
          }else{
            return false;
          }
        }
        if(this.appSettings.user_level==USER_LEVEL.ADMIN){
          return true;
        }
        if(this.appSettings.user_level==USER_LEVEL.TEACHER){
          return true;
        }
        if(this.appSettings.user_level==USER_LEVEL.PARENT){
          return false;
        }
        return false;
      },
       toggleSticky(){
      
      this.check.sticky=!this.check.sticky;
    },
  },
  created(){
   this.loadNewsItem();
  },
  updated(){
   
  },
  mounted(){
   
  }
}

</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.date{
  font-size:.7em;
}
.title{
  font-weight:bold;
}
.text-height{
  height:100px!important;
}
.button-container{
  text-align:right;
  margin-bottom:15px;
}
.btn_add_reaction{
  
  margin:2px;
  font-size:.8em;
  background-color:#D4D4D4;
  border-radius:4px;
  padding:2px 5px;
  display:inline-block;
  cursor:pointer;
  
}
.reaction{
  position:relative;
  border-bottom:1px solid #EEEEEE;
  margin-bottom:15px;
  padding-bottom:10px;
  line-height:20px;
}

.reaction .name{
  font-weight:bold;
  width:100%;
  padding-bottom:10px;
  font-size:1em;
}


.reaction .text{
  width:100%;
  
  font-size:.8em;
}
.clear{
  content:"";
  clear:both;
}
.reaction .avatar{
  margin-right: 10px;
  width:50px;
  height:50px;
  float:left;
  border-radius:9999999px;
  border:1px solid #D4D4D4;
}

.delete{
  cursor:pointer;
  position:absolute;
  top:5px;
  right:5px;
}

.approve-btn-ontainer{
  display:flex;
  
}
.spacer{
  padding:5px;
}

.motivatie{
  margin-top:15px;
  position:relative;
  border:1px solid #707070;
  padding:10px;
  border-radius:4px;
}

.motivatie .label{
  padding: 0 5px;
    position: absolute;
    font-size: .7em;
    display: inline-block;
    background-color: #FFFFFF;
    top: -8px;
    left: 5px;
    z-index: 1;
}

</style>
